import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AttributesService = /** @class */ (function () {
    function AttributesService(http) {
        this.http = http;
        this.endpoints = {
            sdkAttrs: '/dashboard/attrs/v1',
            evtAttrs: '/dashboard/ujmanalytics/vendor/eventattributes'
        };
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    AttributesService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    AttributesService.prototype.getAttributes = function (appId) {
        var endPoint = this.endpoints.sdkAttrs;
        var dataToSend = {
            'params': {
                aid: appId
            }
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    AttributesService.prototype.getEventAttributes = function (vendorId, eventName, appId) {
        var endPoint = this.endpoints.evtAttrs;
        var dataToSend = {
            'params': {
                vid: vendorId,
                en: eventName,
                aid: appId
            }
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    AttributesService.ngInjectableDef = i0.defineInjectable({ factory: function AttributesService_Factory() { return new AttributesService(i0.inject(i1.HttpClient)); }, token: AttributesService, providedIn: "root" });
    return AttributesService;
}());
export { AttributesService };
